/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { supportedGauges } from '../helpers/supportedContracts';
export var Unstake = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'withdraw',
    name: 'withdraw_LP_tokens',
    description: 'Withdraw LP tokens from the gauge.',
    supportedContracts: supportedGauges,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_gauge',
                    options: supportedGauges.filter(function (pool) { return pool.chainId === Number(chainId); }),
                    isPreview: true,
                }),
                methodParams: {
                    amount: new FctValue({ destination: 'wei_amount', decimals: 18, isPreview: true }),
                },
            },
            output: {},
        });
    },
});
